
    import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';
    import { makeObject } from '@/components/editor/utils/editor';
    import { namespace } from 'nuxt-property-decorator';
    import dotProp from 'dot-prop';
    import types, {
        AvailableTypes,
        BaseTypes,
        ComponentMeta,
        OptionApiSource,
        OptionSelect
    } from '@/components/editor/config/types';
    import OptionsFieldsPalette from '@/components/editor/options/fields/OptionsFieldsPalette.vue';
    import OptionsFieldsImage from '@/components/editor/options/fields/OptionsFieldsImage.vue';
    import OptionsFieldsFile from '@/components/editor/options/fields/OptionsFieldsFile.vue';
    import OptionsFieldsString from '@/components/editor/options/fields/OptionsFieldsString.vue';
    import OptionsFieldsPassword from '@/components/editor/options/fields/OptionsFieldsPassword.vue';
    import OptionsFieldsCheckbox from '@/components/editor/options/fields/OptionsFieldsCheckbox.vue';
    import OptionsFieldsColor from '@/components/editor/options/fields/OptionsFieldsColor.vue';
    import OptionsFieldsGroup from '@/components/editor/options/fields/OptionsFieldsGroup.vue';
    import OptionsFieldsSelect from '@/components/editor/options/fields/OptionsFieldsSelect.vue';
    import OptionsFieldsTag from '@/components/editor/options/fields/OptionsFieldsTag.vue';
    import isObj from 'is-obj';
    import OptionsFieldsComponent from '@/components/editor/options/fields/OptionsFieldsComponent.vue';
    import OptionsFieldsWrap from '@/components/editor/options/fields/OptionsFieldsWrap.vue';
    import CyrillicToTranslit from 'cyrillic-to-translit-js';
    import OptionsFieldsGalleryImage from '@/components/editor/options/fields/OptionsFieldsGalleryImage.vue';
    import OptionsFieldsComponentsList from '@/components/editor/options/fields/OptionsFieldsComponentsList.vue';
    import { getComponentMeta } from '@/store/editor';
    import OptionsFieldsPages from '@/components/editor/options/fields/OptionsFieldsPages.vue';
    import OptionsFieldsTextarea from '@/components/editor/options/fields/OptionsFieldsTextarea.vue';
    import OptionsFieldsFullComponentsList from '@/components/editor/options/fields/OptionsFieldsFullComponentsList.vue';
    import OptionsFieldsDate from '@/components/editor/options/fields/OptionsFieldsDate.vue';
    import OptionsFieldsMultiselect from '@/components/editor/options/fields/OptionsFieldsMultiselect.vue';
    import OptionsFieldsPagesMultiselect from '@/components/editor/options/fields/OptionsFieldsPagesMultiselect.vue';
    import OptionsFieldsNumber from '@/components/editor/options/fields/OptionsFieldsNumber.vue';
    import OptionsFieldsCode from '@/components/editor/options/fields/OptionsFieldsCode.vue';
    import OptionsFieldsValueUnit from '@/components/editor/options/fields/OptionsFieldsValueUnit.vue';
    import OptionsFieldsAdditionalComponentsList from '@/components/editor/options/fields/OptionsFieldsAdditionalComponentsList.vue';

    const cyrillicToTranslit = new CyrillicToTranslit();

    const OptionsFieldsEditor = () =>
        import('@/components/editor/options/fields/OptionsFieldsEditor.vue');

    const editor = namespace('editor');
    const user = namespace('user');
    const collections = namespace('collections');

    @Component({
        components: {
            OptionsFieldsAdditionalComponentsList,
            OptionsFieldsWrap,
            OptionsFieldsComponent,
            OptionsFieldsSelect,
            OptionsFieldsGroup,
            OptionsFieldsColor,
            OptionsFieldsCheckbox,
            OptionsFieldsEditor,
            OptionsFieldsTag,
            OptionsFieldsString,
            OptionsFieldsTextarea,
            OptionsFieldsImage,
            OptionsFieldsFile,
            OptionsFieldsPalette,
            OptionsFieldsPages,
            OptionsFieldsPassword,
            OptionsFieldsGalleryImage,
            OptionsFieldsComponentsList,
            OptionsFieldsFullComponentsList,
            OptionsFieldsDate,
            OptionsFieldsMultiselect,
            OptionsFieldsPagesMultiselect,
            OptionsFieldsNumber,
            OptionsFieldsCode,
            OptionsFieldsValueUnit
        },
        name: 'options-fields'
    })
    export default class OptionsFields extends Vue {
        @Prop() option;
        @Prop() keyOption;
        @Prop() entity;
        @Prop() deep;
        @Prop() readonly;
        // @Prop() parentOptionValue;
        @editor.Mutation setPage;
        @editor.Mutation setOptionValue;
        @editor.Mutation addOptionValue;
        @editor.Mutation deleteOptionValue;
        @editor.Mutation setSortOption;
        @collections.Action get;
        @user.State auth;

        values? = [];
        types = types;
        AvailableTypes = AvailableTypes;
        BaseTypes = BaseTypes;
        getComponentMeta = getComponentMeta;
        translit = false;

        additionalFilter = (item: ComponentMeta) => {
            return item.additional;
        };

        id = this.buildId();

        onChangeValue(val) {
            this.$emit('changed', { key: this.keyOption, value: val });

            if (this.readonly) {
                return;
            }
            if (val !== undefined) {
                this.setOptionValue({
                    entity: this.entity,
                    key: this.keyOption,
                    value: val
                });
            }
            if (this.option.translitTo && this.translit) {
                let trans = cyrillicToTranslit.transform(val);
                trans = trans.replace(/ /g, '-').toLowerCase();
                this.setOptionValue({
                    entity: this.entity,
                    key: this.option.translitTo,
                    value: trans
                });
            }
        }

        get optionValue() {
            let entityOptions = this.entity.options;

            if (!entityOptions) {
                entityOptions = this.entity;
            }

            if (dotProp.has(entityOptions, this.keyOption)) {
                let value = dotProp.get(entityOptions, this.keyOption);
                if (this.option.type === AvailableTypes.select && isObj(value)) {
                    let options: OptionSelect = this.option as OptionSelect;
                    if (isObj(options.values)) {
                        if (Array.isArray(value)) {
                            return value;
                        }
                        let apiOptions = options.values as OptionApiSource;
                        if (apiOptions.mappings) {
                            return dotProp.get(value, apiOptions.mappings.value);
                        }
                    }
                } else {
                    return value;
                }
            } else {
                return '';
            }
        }

        getKeyPath(index, key?) {
            if (this.keyOption === '') {
                if (index === key || !key) {
                    return index;
                } else {
                    return `${index}.${key}`;
                }
            } else {
                if (index === key || !key) {
                    return `${this.keyOption}.${index}`;
                } else {
                    return `${this.keyOption}.${index}.${key}`;
                }
            }
        }

        addValue(optionItem) {
            let newItem = makeObject(optionItem);
            this.addOptionValue({
                entity: this.entity,
                key: this.keyOption,
                value: newItem
            });
        }

        deleteValue(index) {
            this.deleteOptionValue({
                entity: this.entity,
                key: this.keyOption,
                index: index
            });
        }

        get cols() {
            return 12;
        }

        buildId(): string {
            return (
                Math.random()
                    .toString(36)
                    .substring(2, 15) +
                Math.random()
                    .toString(36)
                    .substring(2, 15)
            );
        }

        get tabVariant() {
            switch (this.deep) {
                case 1: {
                    return 'info';
                }
                case 2: {
                    return 'success';
                }
                case 3: {
                    return 'warning';
                }
            }
        }

        async fetchValues(option: [] | OptionSelect) {
            if (!Array.isArray(option.values) && isObj(option.values)) {
                option.values = option.values as OptionApiSource;
                if (option.values.type === AvailableTypes.apiSource) {
                    if (typeof option.values['acl'] === 'function') {
                        if (!option.values['acl'](this.auth.permissions)) {
                            return;
                        }
                    }

                    const vals = await this.get({
                        path: (option.values as OptionApiSource).path
                    });

                    const base = option.values['base']
                        ? dotProp.get(vals, option.values['base'])
                        : vals;

                    if (base) {
                        if (option.values.mappings) {
                            this.values = base.map(val => {
                                const ob = {};
                                // @ts-ignore
                                for (let i in option.values.mappings) {
                                    if (
                                        // @ts-ignore
                                        Array.isArray(option.values.mappings[i])
                                    ) {
                                        ob[i] = '';
                                        // @ts-ignore
                                        option.values.mappings[i].forEach(prop => {
                                            ob[i] += ' - ' + dotProp.get(val, prop);
                                        });
                                    } else {
                                        ob[i] = dotProp.get(
                                            val,
                                            // @ts-ignore
                                            option.values.mappings[i]
                                        );
                                    }
                                }
                                return ob;
                            });
                        }
                    }
                }
            } else {
                this.values = option.values;
            }
        }

        @Watch('option', { immediate: true, deep: true })
        update() {
            if (
                this.option.type === AvailableTypes.select &&
                Array.isArray(this.values) &&
                this.values.length === 0
            ) {
                this.fetchValues(this.option);
            }
        }

        setSortOptionAction(option, currentIndex, direction) {
            this.setSortOption({ option, currentIndex, direction });
        }

        isBaseType(option) {
            const type = AvailableTypes[option.type];
            return Object.values(BaseTypes).includes(type);
        }

        getType(option) {
            return AvailableTypes[option.type];
        }

        getTitle(option) {
            if (option.title) {
                return option.title + (option.req ? '*' : '');
            } else {
            }
        }

        getComponent(name, value?) {
            if (!value && name) {
                let meta: ComponentMeta = getComponentMeta(name);
                return { name: name, options: makeObject(meta.options) };
            }
            return value;
        }

        onAdditionalComponentChange(val) {
            if (val) {
                const component = this.getComponent(val);
                this.setOptionValue({
                    entity: this.entity,
                    key: this.keyOption + '.name',
                    value: val
                });
                this.setOptionValue({
                    entity: this.entity,
                    key: this.keyOption + '.options',
                    value: component.options
                });
            } else {
                this.setOptionValue({
                    entity: this.entity,
                    key: this.keyOption,
                    value: { name: '', options: {}, active: false }
                });
            }
        }
    }
